import {
    Breadcrumbs,
    Card,
    Container,
    Figure,
    Grid,
    Link,
    UnorderedList,
    OrderedList,
    Text,
    StyledHtml,
    LinkList,
} from "@postenbring/hedwig-react";
import { ServiceSheetAccordion } from "./service-sheet-accordion";
import { ServiceButtons } from "./service-buttons";
import "./service-sheet.scss";

export const ServiceSheet = ({
    breadcrumbs,
    buttons,
    calculatorLink,
    cards,
    contactUs,
    displayName,
    faq,
    faqLocalization,
    headingSteps,
    intro,
    images,
    prefaceSteps,
    relatedServicesTitle,
    servicePriceData,
    serviceTechnicalData,
    supplementaryServices,
    steps,
}) => (
    <section className="bring-service-sheet">
        <Container className="hds-mb-48-64">
            <Breadcrumbs className="hds-mb-24-32">
                {breadcrumbs.map((crumb) => (
                    <li key={crumb.href}>
                        <Link href={crumb.href}>{crumb.title}</Link>
                    </li>
                ))}
                <li>{displayName}</li>
            </Breadcrumbs>
            <Grid>
                <Grid.Item span={{ initial: 12, large: 8 }}>
                    <Text variant="h1" className="hds-mb-32-40">
                        {displayName}
                    </Text>
                    <Text as="p" variant="h3" className="hds-mb-32-40">
                        {intro.preface}
                    </Text>

                    <ServiceButtons buttons={buttons} contact={contactUs} viewPort="mobile" />

                    {intro.keypoints && intro.keypoints.length > 0 && (
                        <UnorderedList className="hds-mb-24-32">
                            {intro.keypoints.map((point, index) => (
                                <li key={index}>{point.keypoint}</li>
                            ))}
                        </UnorderedList>
                    )}
                    {intro.description && (
                        <StyledHtml
                            className="hds-mb-24-32"
                            dangerouslySetInnerHTML={{ __html: intro.description }}
                        />
                    )}

                    {images && images.length > 0 && (
                        <Figure className="hds-mb-24-32">
                            <img src={images[0].src} alt={images[0].alt} />
                        </Figure>
                    )}
                    {servicePriceData.title && (
                        <Text variant="h2" className="hds-mb-24-32">
                            {servicePriceData.title}
                        </Text>
                    )}
                    {servicePriceData.preface && (
                        <Text as="p" variant="h3" className="hds-mb-24-32">
                            {servicePriceData.preface}
                        </Text>
                    )}
                    {calculatorLink && calculatorLink.links && (
                        <LinkList className="hds-mb-24-32">
                            {calculatorLink.links.map((link, index) => (
                                <li key={index}>
                                    <Link href={link.url}>{link.text}</Link>
                                </li>
                            ))}
                        </LinkList>
                    )}
                    {servicePriceData.description && (
                        <StyledHtml
                            className="hds-mb-24-32"
                            dangerouslySetInnerHTML={{ __html: servicePriceData.description }}
                        />
                    )}
                    {servicePriceData.lists && (
                        <>
                            {servicePriceData.lists.map(
                                (list, index) =>
                                    list &&
                                    list.links && (
                                        <LinkList className="hds-mb-24-32" key={index}>
                                            {list.links.map((link, index) => (
                                                <li key={index}>
                                                    <Link
                                                        href={link.href}
                                                        target={link.target}
                                                        className="hds-mb-16"
                                                    >
                                                        {link.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </LinkList>
                                    ),
                            )}
                        </>
                    )}
                    {serviceTechnicalData.title && (
                        <Text variant="h2" className="hds-mb-24-32">
                            {serviceTechnicalData.title}
                        </Text>
                    )}
                    {serviceTechnicalData.preface && (
                        <Text as="p" variant="h3" className="hds-mb-24-32">
                            {serviceTechnicalData.preface}
                        </Text>
                    )}
                    {serviceTechnicalData.details && (
                        <>
                            {serviceTechnicalData.details.map((detail, index) => (
                                <StyledHtml
                                    key={index}
                                    className="hds-mb-24-32"
                                    dangerouslySetInnerHTML={{ __html: detail.content }}
                                />
                            ))}
                        </>
                    )}
                    {serviceTechnicalData.links && (
                        <LinkList className="hds-mb-24-32">
                            {serviceTechnicalData.links.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        href={link.href}
                                        target={link.target}
                                        className="hds-mb-16"
                                    >
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </LinkList>
                    )}

                    {/* <!-- steps --> */}
                    {steps && steps.length > 0 && (
                        <>
                            {headingSteps && (
                                <Text variant="h2" className="hds-mb-24-32">
                                    {headingSteps}
                                </Text>
                            )}
                            {prefaceSteps && (
                                <Text as="p" variant="h3" className="hds-mb-24-32">
                                    {prefaceSteps}
                                </Text>
                            )}

                            <OrderedList>
                                {steps.map((step, index) => (
                                    <li key={index}>
                                        <Text as="p" variant="body-title" className="hds-mb-16">
                                            {step.title}
                                        </Text>
                                        <StyledHtml
                                            className="hds-mb-24-32"
                                            dangerouslySetInnerHTML={{ __html: step.text }}
                                        />
                                    </li>
                                ))}
                            </OrderedList>
                        </>
                    )}
                    {(supplementaryServices || faq) && (
                        <>
                            <ServiceSheetAccordion
                                supplementaryServices={supplementaryServices}
                                faq={faq}
                                localization={faqLocalization}
                            />
                        </>
                    )}
                </Grid.Item>
                <Grid.Item span={{ initial: 12, large: 1 }}></Grid.Item>
                <Grid.Item span={{ initial: 12, large: 3 }}>
                    <ServiceButtons buttons={buttons} contact={contactUs} viewPort="desktop" />
                </Grid.Item>
            </Grid>
            {cards && cards.length > 0 && (
                <>
                    <Text variant="h2" className="hds-mb-24-32">
                        {relatedServicesTitle}
                    </Text>
                    <Grid span={{ initial: 12, large: 4 }} gap="12-16">
                        {cards.map((card, index) => (
                            <Card key={index}>
                                {card.imgUrl && (
                                    <Card.Media>
                                        <Card.MediaImg src={card.imgUrl} />
                                    </Card.Media>
                                )}
                                <Card.Body>
                                    <Card.BodyHeader as="h3">
                                        <Card.BodyHeaderTitle>{card.title}</Card.BodyHeaderTitle>
                                    </Card.BodyHeader>
                                    <Card.BodyDescription>{card.description}</Card.BodyDescription>
                                    <Card.BodyAction>
                                        <Link
                                            href={card.url}
                                            variant="solid"
                                            target={card.newTab ? "_blank" : "_self"}
                                        >
                                            <Card.BodyActionArrow direction={card.arrowDirection} />
                                            {card.linkText}
                                        </Link>
                                    </Card.BodyAction>
                                </Card.Body>
                            </Card>
                        ))}
                    </Grid>
                </>
            )}
        </Container>
    </section>
);
